"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Hotel = _interopRequireDefault(require("@material-ui/icons/Hotel"));
var _Flight = _interopRequireDefault(require("@material-ui/icons/Flight"));
var _FilterHdr = _interopRequireDefault(require("@material-ui/icons/FilterHdr"));
var _People = _interopRequireDefault(require("@material-ui/icons/People"));
var _BeachAccess = _interopRequireDefault(require("@material-ui/icons/BeachAccess"));
var _Whatshot = _interopRequireDefault(require("@material-ui/icons/Whatshot"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _LocationOn = _interopRequireDefault(require("@material-ui/icons/LocationOn"));
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));
var _Star = _interopRequireDefault(require("@material-ui/icons/Star"));
var _StarHalf = _interopRequireDefault(require("@material-ui/icons/StarHalf"));
var _StarBorder = _interopRequireDefault(require("@material-ui/icons/StarBorder"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _Notifications = _interopRequireDefault(require("@material-ui/icons/Notifications"));
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _AddCircle = _interopRequireDefault(require("@material-ui/icons/AddCircle"));
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _DateRange = _interopRequireDefault(require("@material-ui/icons/DateRange"));
var _AccessTime = _interopRequireDefault(require("@material-ui/icons/AccessTime"));
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _Facebook = _interopRequireDefault(require("@material-ui/icons/Facebook"));
var _Twitter = _interopRequireDefault(require("@material-ui/icons/Twitter"));
var _Instagram = _interopRequireDefault(require("@material-ui/icons/Instagram"));
var _YouTube = _interopRequireDefault(require("@material-ui/icons/YouTube"));
var _LinkedIn = _interopRequireDefault(require("@material-ui/icons/LinkedIn"));
var _Pinterest = _interopRequireDefault(require("@material-ui/icons/Pinterest"));
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));
var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));
var _ArrowForwardIos = _interopRequireDefault(require("@material-ui/icons/ArrowForwardIos"));
var _Language = _interopRequireDefault(require("@material-ui/icons/Language"));
var _Public = _interopRequireDefault(require("@material-ui/icons/Public"));
var _MonetizationOn = _interopRequireDefault(require("@material-ui/icons/MonetizationOn"));
var _AccountCircle = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));
var _AccountBox = _interopRequireDefault(require("@material-ui/icons/AccountBox"));
var _FeaturedPlayList = _interopRequireDefault(require("@material-ui/icons/FeaturedPlayList"));
var _LibraryBooks = _interopRequireDefault(require("@material-ui/icons/LibraryBooks"));
var _CreditCard = _interopRequireDefault(require("@material-ui/icons/CreditCard"));
var _AssignmentTurnedIn = _interopRequireDefault(require("@material-ui/icons/AssignmentTurnedIn"));
var _Money = _interopRequireDefault(require("@material-ui/icons/Money"));
var _AttachMoney = _interopRequireDefault(require("@material-ui/icons/AttachMoney"));
var _PlayCircleOutline = _interopRequireDefault(require("@material-ui/icons/PlayCircleOutline"));
var _PauseCircleOutline = _interopRequireDefault(require("@material-ui/icons/PauseCircleOutline"));
var _Home = _interopRequireDefault(require("@material-ui/icons/Home"));
var _CollectionsBookmark = _interopRequireDefault(require("@material-ui/icons/CollectionsBookmark"));
var _PlaylistAddCheck = _interopRequireDefault(require("@material-ui/icons/PlaylistAddCheck"));
var _FlightTakeoff = _interopRequireDefault(require("@material-ui/icons/FlightTakeoff"));
var _Forum = _interopRequireDefault(require("@material-ui/icons/Forum"));
var _Person = _interopRequireDefault(require("@material-ui/icons/Person"));
var _DirectionsBoat = _interopRequireDefault(require("@material-ui/icons/DirectionsBoat"));
var _DirectionsBus = _interopRequireDefault(require("@material-ui/icons/DirectionsBus"));
var _Train = _interopRequireDefault(require("@material-ui/icons/Train"));
var _DriveEta = _interopRequireDefault(require("@material-ui/icons/DriveEta"));
var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));
var _SwapHoriz = _interopRequireDefault(require("@material-ui/icons/SwapHoriz"));
var _FiberManualRecord = _interopRequireDefault(require("@material-ui/icons/FiberManualRecord"));
var _ArrowRightAlt = _interopRequireDefault(require("@material-ui/icons/ArrowRightAlt"));
var _Sort = _interopRequireDefault(require("@material-ui/icons/Sort"));
var _FilterList = _interopRequireDefault(require("@material-ui/icons/FilterList"));
var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));
var _AttachFile = _interopRequireDefault(require("@material-ui/icons/AttachFile"));
var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));
var _Room = _interopRequireDefault(require("@material-ui/icons/Room"));
var _PanoramaFishEye = _interopRequireDefault(require("@material-ui/icons/PanoramaFishEye"));
var _TripOrigin = _interopRequireDefault(require("@material-ui/icons/TripOrigin"));
var _Shuffle = _interopRequireDefault(require("@material-ui/icons/Shuffle"));
var _TransferWithinAStation = _interopRequireDefault(require("@material-ui/icons/TransferWithinAStation"));
var _VerifiedUser = _interopRequireDefault(require("@material-ui/icons/VerifiedUser"));
var _ShoppingCart = _interopRequireDefault(require("@material-ui/icons/ShoppingCart"));
var _ChildCare = _interopRequireDefault(require("@material-ui/icons/ChildCare"));
var _ChildFriendly = _interopRequireDefault(require("@material-ui/icons/ChildFriendly"));
var _PermIdentity = _interopRequireDefault(require("@material-ui/icons/PermIdentity"));
var _History = _interopRequireDefault(require("@material-ui/icons/History"));
var _CheckCircleOutline = _interopRequireDefault(require("@material-ui/icons/CheckCircleOutline"));
var _DescriptionOutlined = _interopRequireDefault(require("@material-ui/icons/DescriptionOutlined"));
var _RecentActorsOutlined = _interopRequireDefault(require("@material-ui/icons/RecentActorsOutlined"));
var _CallMade = _interopRequireDefault(require("@material-ui/icons/CallMade"));
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));
var _Apartment = _interopRequireDefault(require("@material-ui/icons/Apartment"));
var _Map = _interopRequireDefault(require("@material-ui/icons/Map"));
var _HighlightOff = _interopRequireDefault(require("@material-ui/icons/HighlightOff"));
var _TrendingUp = _interopRequireDefault(require("@material-ui/icons/TrendingUp"));
var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));
var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));
var _LocalGasStation = _interopRequireDefault(require("@material-ui/icons/LocalGasStation"));
var _Block = _interopRequireDefault(require("@material-ui/icons/Block"));
var _GetApp = _interopRequireDefault(require("@material-ui/icons/GetApp"));
var _WorkOff = _interopRequireDefault(require("@material-ui/icons/WorkOff"));
var _Accessible = _interopRequireDefault(require("@material-ui/icons/Accessible"));
var _SupervisedUserCircle = _interopRequireDefault(require("@material-ui/icons/SupervisedUserCircle"));
var _ConfirmationNumber = _interopRequireDefault(require("@material-ui/icons/ConfirmationNumber"));
var _Wifi = _interopRequireDefault(require("@material-ui/icons/Wifi"));
var _Pool = _interopRequireDefault(require("@material-ui/icons/Pool"));
var _FitnessCenter = _interopRequireDefault(require("@material-ui/icons/FitnessCenter"));
var _Spa = _interopRequireDefault(require("@material-ui/icons/Spa"));
var _Waves = _interopRequireDefault(require("@material-ui/icons/Waves"));
var _AirportShuttle = _interopRequireDefault(require("@material-ui/icons/AirportShuttle"));
var _SmokingRooms = _interopRequireDefault(require("@material-ui/icons/SmokingRooms"));
var _SmokeFree = _interopRequireDefault(require("@material-ui/icons/SmokeFree"));
var _Restaurant = _interopRequireDefault(require("@material-ui/icons/Restaurant"));
var _LocalCafe = _interopRequireDefault(require("@material-ui/icons/LocalCafe"));
var _LocalBar = _interopRequireDefault(require("@material-ui/icons/LocalBar"));
var _SportsTennis = _interopRequireDefault(require("@material-ui/icons/SportsTennis"));
var _HotTub = _interopRequireDefault(require("@material-ui/icons/HotTub"));
var _LocalParking = _interopRequireDefault(require("@material-ui/icons/LocalParking"));
var _RoomService = _interopRequireDefault(require("@material-ui/icons/RoomService"));
var _LocalLaundryService = _interopRequireDefault(require("@material-ui/icons/LocalLaundryService"));
var _BusinessCenter = _interopRequireDefault(require("@material-ui/icons/BusinessCenter"));
var _FlightLand = _interopRequireDefault(require("@material-ui/icons/FlightLand"));
var _SubdirectoryArrowRight = _interopRequireDefault(require("@material-ui/icons/SubdirectoryArrowRight"));
var _AirplanemodeActive = _interopRequireDefault(require("@material-ui/icons/AirplanemodeActive"));
var _Collections = _interopRequireDefault(require("@material-ui/icons/Collections"));
var _Email = _interopRequireDefault(require("@material-ui/icons/Email"));
var _ErrorOutline = _interopRequireDefault(require("@material-ui/icons/ErrorOutline"));
var _Input = _interopRequireDefault(require("@material-ui/icons/Input"));
var _InsertEmoticon = _interopRequireDefault(require("@material-ui/icons/InsertEmoticon"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _ArrowDropUp = _interopRequireDefault(require("@material-ui/icons/ArrowDropUp"));
var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));
var _Phone = _interopRequireDefault(require("@material-ui/icons/Phone"));
var _FlashOnRounded = _interopRequireDefault(require("@material-ui/icons/FlashOnRounded"));
var _MoreHorizOutlined = _interopRequireDefault(require("@material-ui/icons/MoreHorizOutlined"));
var _PhotoLibrary = _interopRequireDefault(require("@material-ui/icons/PhotoLibrary"));
var _Timer = _interopRequireDefault(require("@material-ui/icons/Timer"));
var _AvTimer = _interopRequireDefault(require("@material-ui/icons/AvTimer"));
var _KeyboardArrowUp = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowUp"));
var _Brightness = _interopRequireDefault(require("@material-ui/icons/Brightness1"));
var _Group = _interopRequireDefault(require("@material-ui/icons/Group"));
var _Security = _interopRequireDefault(require("@material-ui/icons/Security"));
var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));
var _ThumbUp = _interopRequireDefault(require("@material-ui/icons/ThumbUp"));
var _ThumbDown = _interopRequireDefault(require("@material-ui/icons/ThumbDown"));
var _AirlineSeatFlat = _interopRequireDefault(require("@material-ui/icons/AirlineSeatFlat"));
var _Tv = _interopRequireDefault(require("@material-ui/icons/Tv"));
var _AcUnit = _interopRequireDefault(require("@material-ui/icons/AcUnit"));
var _CallToAction = _interopRequireDefault(require("@material-ui/icons/CallToAction"));
var _Bathtub = _interopRequireDefault(require("@material-ui/icons/Bathtub"));
var _ViewCompact = _interopRequireDefault(require("@material-ui/icons/ViewCompact"));
var _Kitchen = _interopRequireDefault(require("@material-ui/icons/Kitchen"));
var _LocalDrink = _interopRequireDefault(require("@material-ui/icons/LocalDrink"));
var _RvHookup = _interopRequireDefault(require("@material-ui/icons/RvHookup"));
var _Stars = _interopRequireDefault(require("@material-ui/icons/Stars"));
var _StarsRounded = _interopRequireDefault(require("@material-ui/icons/StarsRounded"));
var _Assistant = _interopRequireDefault(require("@material-ui/icons/Assistant"));
var _TouchApp = _interopRequireDefault(require("@material-ui/icons/TouchApp"));
var _Looks = _interopRequireDefault(require("@material-ui/icons/Looks"));
var _VideoLabel = _interopRequireDefault(require("@material-ui/icons/VideoLabel"));
var _Extension = _interopRequireDefault(require("@material-ui/icons/Extension"));
var _LocalOfferOutlined = _interopRequireDefault(require("@material-ui/icons/LocalOfferOutlined"));
var _Warning = _interopRequireDefault(require("@material-ui/icons/Warning"));
var _Timeline = _interopRequireDefault(require("@material-ui/icons/Timeline"));
var _Receipt = _interopRequireDefault(require("@material-ui/icons/Receipt"));
var _PhotoCamera = _interopRequireDefault(require("@material-ui/icons/PhotoCamera"));
var _AirlineSeatReclineNormal = _interopRequireDefault(require("@material-ui/icons/AirlineSeatReclineNormal"));
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
var _AirplanemodeInactive = _interopRequireDefault(require("@material-ui/icons/AirplanemodeInactive"));
var _HourglassFull = _interopRequireDefault(require("@material-ui/icons/HourglassFull"));
var _ListAlt = _interopRequireDefault(require("@material-ui/icons/ListAlt"));
var _ContactPhone = _interopRequireDefault(require("@material-ui/icons/ContactPhone"));
var _CallSplit = _interopRequireDefault(require("@material-ui/icons/CallSplit"));
var _MonetizationOnRounded = _interopRequireDefault(require("@material-ui/icons/MonetizationOnRounded"));
var _SyncAlt = _interopRequireDefault(require("@material-ui/icons/SyncAlt"));
var _LocalActivity = _interopRequireDefault(require("@material-ui/icons/LocalActivity"));
var _setMeal = _interopRequireDefault(require("./statics/setMeal"));
var _liquor = _interopRequireDefault(require("./statics/liquor"));
var _balcony = _interopRequireDefault(require("./statics/balcony"));
var _toiletries = _interopRequireDefault(require("./statics/toiletries"));
var _freeBottledWater = _interopRequireDefault(require("./statics/freeBottledWater"));
var _microwave = _interopRequireDefault(require("./statics/microwave"));
var _hairDryer = _interopRequireDefault(require("./statics/hairDryer"));
var _wineBottle = _interopRequireDefault(require("./statics/wineBottle"));
var _island_transfer = _interopRequireDefault(require("./statics/island_transfer"));
var _change_currency = _interopRequireDefault(require("./statics/change_currency"));
var _infant = _interopRequireDefault(require("./statics/infant"));
var _arrow_up = _interopRequireDefault(require("./statics/arrow_up"));
var _FlightReverseIcon = _interopRequireDefault(require("./statics/FlightReverseIcon"));
var _cancel = _interopRequireDefault(require("./statics/cancel"));
var _hotel = _interopRequireDefault(require("./statics/hotel"));
var _smallBaggage = _interopRequireDefault(require("./statics/smallBaggage"));
var _largeBaggage = _interopRequireDefault(require("./statics/largeBaggage"));
var _sports_equipment = _interopRequireDefault(require("./statics/sports_equipment"));
var _sports_bicycle = _interopRequireDefault(require("./statics/sports_bicycle"));
var _sports_cricket = _interopRequireDefault(require("./statics/sports_cricket"));
var _sports_golf = _interopRequireDefault(require("./statics/sports_golf"));
var _sports_ski = _interopRequireDefault(require("./statics/sports_ski"));
var _sports_surfing = _interopRequireDefault(require("./statics/sports_surfing"));
var _sports_diving = _interopRequireDefault(require("./statics/sports_diving"));
var _smallBag = _interopRequireDefault(require("./statics/smallBag"));
var _poolside_bar = _interopRequireDefault(require("./statics/poolside_bar"));
var _nightclub = _interopRequireDefault(require("./statics/nightclub"));
var _logo_amex = _interopRequireDefault(require("./statics/logo_amex"));
var _logo_bigPay = _interopRequireDefault(require("./statics/logo_bigPay"));
var _logo_masterCard = _interopRequireDefault(require("./statics/logo_masterCard"));
var _logo_visa = _interopRequireDefault(require("./statics/logo_visa"));
var _logo_visa_blue = _interopRequireDefault(require("./statics/logo_visa_blue"));
var _logo_unionPay = _interopRequireDefault(require("./statics/logo_unionPay"));
var _logo_jcb = _interopRequireDefault(require("./statics/logo_jcb"));
var _adult = _interopRequireDefault(require("./statics/adult"));
var _child = _interopRequireDefault(require("./statics/child"));
var _luggage_storage = _interopRequireDefault(require("./statics/luggage_storage"));
var _garden = _interopRequireDefault(require("./statics/garden"));
var _concierge_services = _interopRequireDefault(require("./statics/concierge_services"));
var _star_inverted_icon = _interopRequireDefault(require("./statics/star_inverted_icon"));
var _cross_icon = _interopRequireDefault(require("./statics/cross_icon"));
var _volume_off_icon = _interopRequireDefault(require("./statics/volume_off_icon"));
var _bassinet_icon = _interopRequireDefault(require("./statics/bassinet_icon"));
var _flatbed_icon = _interopRequireDefault(require("./statics/flatbed_icon"));
var _flatbed_bundled_icon = _interopRequireDefault(require("./statics/flatbed_bundled_icon"));
var _flatbed_selected_icon = _interopRequireDefault(require("./statics/flatbed_selected_icon"));
var _flatbed_unavailable_icon = _interopRequireDefault(require("./statics/flatbed_unavailable_icon"));
var _direction_run = _interopRequireDefault(require("./statics/direction_run"));
var _washroom = _interopRequireDefault(require("./statics/washroom"));
var _CheckoutButtonLogo = _interopRequireDefault(require("./statics/CheckoutButtonLogo"));
var _jcb_trust_mark_logo = _interopRequireDefault(require("./statics/jcb_trust_mark_logo"));
var _visa_trust_mark_logo = _interopRequireDefault(require("./statics/visa_trust_mark_logo"));
var _pci_trust_mark_logo = _interopRequireDefault(require("./statics/pci_trust_mark_logo"));
var _mastercard_trust_mark_logo = _interopRequireDefault(require("./statics/mastercard_trust_mark_logo"));
var _shield_trust_mark_logo = _interopRequireDefault(require("./statics/shield_trust_mark_logo"));
var _disableCheckIcon = _interopRequireDefault(require("./statics/disableCheckIcon"));
var _discountPromo = _interopRequireDefault(require("./statics/discountPromo"));
var _discountPromoMobile = _interopRequireDefault(require("./statics/discountPromoMobile"));
var _blocked_icon = _interopRequireDefault(require("./statics/blocked_icon"));
var _aalogo = _interopRequireDefault(require("./statics/aalogo"));
var _super_certified = _interopRequireDefault(require("./statics/super_certified"));
var _duty_free_icon = _interopRequireDefault(require("./statics/duty_free_icon"));
var _cvv = _interopRequireDefault(require("./statics/cvv"));
var _hotelConfirmed = _interopRequireDefault(require("./statics/hotelConfirmed"));
var _hotelCancelled = _interopRequireDefault(require("./statics/hotelCancelled"));
var _place = _interopRequireDefault(require("./statics/place"));
var _payments = _interopRequireDefault(require("./statics/payments"));
var _boardingPass = _interopRequireDefault(require("./statics/boardingPass"));
var _checkinIcon = _interopRequireDefault(require("./statics/checkinIcon"));
var _airline_seat_individual_suite = _interopRequireDefault(require("./statics/airline_seat_individual_suite"));
var _airline_seat_recline_extra = _interopRequireDefault(require("./statics/airline_seat_recline_extra"));
var _double_arrow = _interopRequireDefault(require("./statics/double_arrow"));
var _edit_calendar = _interopRequireDefault(require("./statics/edit_calendar"));
var _event_seat = _interopRequireDefault(require("./statics/event_seat"));
var _health_and_safety = _interopRequireDefault(require("./statics/health_and_safety"));
var _luggage = _interopRequireDefault(require("./statics/luggage"));
var _notificationUnfilled = _interopRequireDefault(require("./statics/notificationUnfilled"));
var _add_circle = _interopRequireDefault(require("./statics/add_circle"));
var _supportAgent = _interopRequireDefault(require("./statics/supportAgent"));
var _new_accessible = _interopRequireDefault(require("./statics/new_accessible"));
var _new_adult = _interopRequireDefault(require("./statics/new_adult"));
var _new_baggage = _interopRequireDefault(require("./statics/new_baggage"));
var _new_bundle = _interopRequireDefault(require("./statics/new_bundle"));
var _new_reschedule = _interopRequireDefault(require("./statics/new_reschedule"));
var _new_cancel_flight = _interopRequireDefault(require("./statics/new_cancel_flight"));
var _new_check_in = _interopRequireDefault(require("./statics/new_check_in"));
var _new_child = _interopRequireDefault(require("./statics/new_child"));
var _new_comfort_kit = _interopRequireDefault(require("./statics/new_comfort_kit"));
var _new_currency_exchange = _interopRequireDefault(require("./statics/new_currency_exchange"));
var _new_edit_contact = _interopRequireDefault(require("./statics/new_edit_contact"));
var _new_express_baggage = _interopRequireDefault(require("./statics/new_express_baggage"));
var _new_extra_carry_on = _interopRequireDefault(require("./statics/new_extra_carry_on"));
var _new_fastpass = _interopRequireDefault(require("./statics/new_fastpass"));
var _new_ferry = _interopRequireDefault(require("./statics/new_ferry"));
var _new_flatbed = _interopRequireDefault(require("./statics/new_flatbed"));
var _new_flight_indicator = _interopRequireDefault(require("./statics/new_flight_indicator"));
var _new_infant = _interopRequireDefault(require("./statics/new_infant"));
var _new_landing = _interopRequireDefault(require("./statics/new_landing"));
var _new_layover = _interopRequireDefault(require("./statics/new_layover"));
var _new_location = _interopRequireDefault(require("./statics/new_location"));
var _new_lounge = _interopRequireDefault(require("./statics/new_lounge"));
var _new_luggage = _interopRequireDefault(require("./statics/new_luggage"));
var _new_manage_booking = _interopRequireDefault(require("./statics/new_manage_booking"));
var _new_meal = _interopRequireDefault(require("./statics/new_meal"));
var _new_origin = _interopRequireDefault(require("./statics/new_origin"));
var _new_others = _interopRequireDefault(require("./statics/new_others"));
var _new_points = _interopRequireDefault(require("./statics/new_points"));
var _new_seat = _interopRequireDefault(require("./statics/new_seat"));
var _new_security = _interopRequireDefault(require("./statics/new_security"));
var _new_split = _interopRequireDefault(require("./statics/new_split"));
var _new_sports_equipment = _interopRequireDefault(require("./statics/new_sports_equipment"));
var _new_take_off = _interopRequireDefault(require("./statics/new_take_off"));
var _new_technical_stop = _interopRequireDefault(require("./statics/new_technical_stop"));
var _new_ticket = _interopRequireDefault(require("./statics/new_ticket"));
var _location_point = _interopRequireDefault(require("./statics/location_point"));
var _comfort_kit_icon = _interopRequireDefault(require("./statics/comfort_kit_icon"));
var _CurtainsIcon = _interopRequireDefault(require("./statics/CurtainsIcon"));
var _PeopleIcon = _interopRequireDefault(require("./statics/PeopleIcon"));
var _ZoomOutMap = _interopRequireDefault(require("./statics/ZoomOutMap"));
var _cloud = _interopRequireDefault(require("./statics/cloud"));
/* eslint-disable import/no-duplicates */
var _default = {
  Menu: _Menu.default,
  Person: _Person.default,
  ArrowBackIos: _ArrowBackIos.default,
  ArrowForwardIos: _ArrowForwardIos.default,
  ArrowForward: _ArrowForward.default,
  AccountBox: _AccountBox.default,
  FeaturedPlayList: _FeaturedPlayList.default,
  LibraryBooks: _LibraryBooks.default,
  CreditCard: _CreditCard.default,
  AssignmentTurnedIn: _AssignmentTurnedIn.default,
  Money: _Money.default,
  AttachMoney: _AttachMoney.default,
  HotelIcon: _Hotel.default,
  FlightIcon: _Flight.default,
  FilterHdrIcon: _FilterHdr.default,
  PeopleIcon: _People.default,
  BeachAccessIcon: _BeachAccess.default,
  WhatshotIcon: _Whatshot.default,
  DeleteIcon: _Delete.default,
  LocationOnIcon: _LocationOn.default,
  ChevronRightIcon: _ChevronRight.default,
  ChevronLeftIcon: _ChevronLeft.default,
  StarIcon: _Star.default,
  StarHalfIcon: _StarHalf.default,
  StarBorderIcon: _StarBorder.default,
  CloseIcon: _Close.default,
  DisableCheckIcon: _disableCheckIcon.default,
  DiscountPromoLogo: _discountPromo.default,
  DiscountPromoLogoMobile: _discountPromoMobile.default,
  InfoOutlinedIcon: _InfoOutlined.default,
  CheckIcon: _Check.default,
  NotificationsIcon: _Notifications.default,
  AddIcon: _Add.default,
  RemoveIcon: _Remove.default,
  ErrorIcon: _Error.default,
  DateRangeIcon: _DateRange.default,
  AccessTimeIcon: _AccessTime.default,
  ExpandLessIcon: _ExpandLess.default,
  ExpandMoreIcon: _ExpandMore.default,
  FacebookIcon: _Facebook.default,
  TwitterIcon: _Twitter.default,
  InstagramIcon: _Instagram.default,
  YouTubeIcon: _YouTube.default,
  LinkedInIcon: _LinkedIn.default,
  PinterestIcon: _Pinterest.default,
  KeyboardArrowLeftIcon: _KeyboardArrowLeft.default,
  ArrowBackIcon: _ArrowBack.default,
  LanguageIcon: _Language.default,
  PublicIcon: _Public.default,
  MonetizationOnIcon: _MonetizationOn.default,
  AccountCircle: _AccountCircle.default,
  PlayCircleOutlineIcon: _PlayCircleOutline.default,
  PauseCircleOutlineIcon: _PauseCircleOutline.default,
  HomeIcon: _Home.default,
  CollectionsBookmarkIcon: _CollectionsBookmark.default,
  PlaylistAddCheckIcon: _PlaylistAddCheck.default,
  FlightTakeoffIcon: _FlightTakeoff.default,
  FlightLand: _FlightLand.default,
  SubdirectoryArrowRight: _SubdirectoryArrowRight.default,
  ForumIcon: _Forum.default,
  DirectionsBoat: _DirectionsBoat.default,
  DirectionsBus: _DirectionsBus.default,
  Train: _Train.default,
  DriveEta: _DriveEta.default,
  EditIcon: _Edit.default,
  SwapHorizIcon: _SwapHoriz.default,
  FiberManualRecordIcon: _FiberManualRecord.default,
  ArrowRightAltIcon: _ArrowRightAlt.default,
  Sort: _Sort.default,
  FilterList: _FilterList.default,
  Search: _Search.default,
  AttachFileIcon: _AttachFile.default,
  CheckCircleIcon: _CheckCircle.default,
  RoomIcon: _Room.default,
  PanoramaFishEyeIcon: _PanoramaFishEye.default,
  TripOriginIcon: _TripOrigin.default,
  ShuffleIcon: _Shuffle.default,
  TransferWithinAStationIcon: _TransferWithinAStation.default,
  VerifiedUserIcon: _VerifiedUser.default,
  ShoppingCartIcon: _ShoppingCart.default,
  ChildCareIcon: _ChildCare.default,
  ChildFriendlyIcon: _ChildFriendly.default,
  PermIdentityIcon: _PermIdentity.default,
  History: _History.default,
  CheckCircleOutlineIcon: _CheckCircleOutline.default,
  DescriptionOutlinedIcon: _DescriptionOutlined.default,
  RecentActorsOutlinedIcon: _RecentActorsOutlined.default,
  CallMadeIcon: _CallMade.default,
  ArrowDropDownIcon: _ArrowDropDown.default,
  ApartmentIcon: _Apartment.default,
  IslandTransfer: _island_transfer.default,
  MapIcon: _Map.default,
  HighlightOff: _HighlightOff.default,
  TrendingUpIcon: _TrendingUp.default,
  VisibilityOffIcon: _VisibilityOff.default,
  VisibilityIcon: _Visibility.default,
  LocalGasStationIcon: _LocalGasStation.default,
  BlockIcon: _Block.default,
  GetAppIcon: _GetApp.default,
  ChangeCurrency: _change_currency.default,
  AccessibleIcon: _Accessible.default,
  InfantIcon: _infant.default,
  ArrowUp: _arrow_up.default,
  FlightReverseIcon: _FlightReverseIcon.default,
  WorkOffIcon: _WorkOff.default,
  CancelIcon: _cancel.default,
  NewHotelIcon: _hotel.default,
  SmallBaggage: _smallBaggage.default,
  LargeBaggage: _largeBaggage.default,
  SupervisedUserCircle: _SupervisedUserCircle.default,
  ConfirmationNumberIcon: _ConfirmationNumber.default,
  SportsEquipment: _sports_equipment.default,
  SportsBicycle: _sports_bicycle.default,
  SportsCricket: _sports_cricket.default,
  SportsGolf: _sports_golf.default,
  SportsSki: _sports_ski.default,
  SportsSurfing: _sports_surfing.default,
  SportsDiving: _sports_diving.default,
  SmallBag: _smallBag.default,
  WifiIcon: _Wifi.default,
  PoolIcon: _Pool.default,
  FitnessCenterIcon: _FitnessCenter.default,
  SpaIcon: _Spa.default,
  WavesIcon: _Waves.default,
  AirportShuttleIcon: _AirportShuttle.default,
  SmokingRoomsIcon: _SmokingRooms.default,
  SmokeFreeIcon: _SmokeFree.default,
  RestaurantIcon: _Restaurant.default,
  PoolsideBar: _poolside_bar.default,
  LocalCafeIcon: _LocalCafe.default,
  LocalBarIcon: _LocalBar.default,
  SportsTennisIcon: _SportsTennis.default,
  HotTubIcon: _HotTub.default,
  NightclubIcon: _nightclub.default,
  LocalParkingIcon: _LocalParking.default,
  RoomServiceIcon: _RoomService.default,
  LocalLaundryServiceIcon: _LocalLaundryService.default,
  BusinessCenterIcon: _BusinessCenter.default,
  AmexLogo: _logo_amex.default,
  BigPayLogo: _logo_bigPay.default,
  MasterCardLogo: _logo_masterCard.default,
  VisaLogo: _logo_visa.default,
  VisaBlueLogo: _logo_visa_blue.default,
  UnionPayLogo: _logo_unionPay.default,
  JcbLogo: _logo_jcb.default,
  AirplaneModeActiveIcon: _AirplanemodeActive.default,
  CollectionsIcon: _Collections.default,
  EmailIcon: _Email.default,
  ErrorOutlineIcon: _ErrorOutline.default,
  InputIcon: _Input.default,
  InsertEmoticon: _InsertEmoticon.default,
  KeyboardArrowRight: _KeyboardArrowRight.default,
  ArrowDropUpIcon: _ArrowDropUp.default,
  DoneIcon: _Done.default,
  PhoneIcon: _Phone.default,
  PhotoLibraryIcon: _PhotoLibrary.default,
  CreditCardIcon: _CreditCard.default,
  AdultSleepIcon: _adult.default,
  ChildSleepIcon: _child.default,
  FlashOnRoundedIcon: _FlashOnRounded.default,
  MoreHorizOutlinedIcon: _MoreHorizOutlined.default,
  LuggageStorageIcon: _luggage_storage.default,
  GardenIcon: _garden.default,
  ConciergeServicesIcon: _concierge_services.default,
  TimerIcon: _Timer.default,
  GroupIcon: _Group.default,
  StarInvertedIcon: _star_inverted_icon.default,
  CrossIcon: _cross_icon.default,
  VolumeOffIcon: _volume_off_icon.default,
  BassinetIcon: _bassinet_icon.default,
  FlatbedIcon: _flatbed_icon.default,
  FlatbedBundledIcon: _flatbed_bundled_icon.default,
  FlatbedSelectedIcon: _flatbed_selected_icon.default,
  FlatbedUnavailableIcon: _flatbed_unavailable_icon.default,
  SecurityIcon: _Security.default,
  DotIcon: _Brightness.default,
  AddCircleIcon: _AddCircle.default,
  InfoIcon: _Info.default,
  DirectionRunIcon: _direction_run.default,
  WashroomIcon: _washroom.default,
  KeyboardArrowUpIcon: _KeyboardArrowUp.default,
  CheckoutButtonLogo: _CheckoutButtonLogo.default,
  JcbTrustMarkLogo: _jcb_trust_mark_logo.default,
  VisaTrustMarkLogo: _visa_trust_mark_logo.default,
  PCITrustMarkLogo: _pci_trust_mark_logo.default,
  MasterCardTrustMarkLogo: _mastercard_trust_mark_logo.default,
  ShieldTrustMarkLogo: _shield_trust_mark_logo.default,
  ThumbUp: _ThumbUp.default,
  ThumbDown: _ThumbDown.default,
  AirlineSeatFlatIcon: _AirlineSeatFlat.default,
  TvIcon: _Tv.default,
  AcUnitIcon: _AcUnit.default,
  CallToActionIcon: _CallToAction.default,
  BathtubIcon: _Bathtub.default,
  ViewCompactIcon: _ViewCompact.default,
  KitchenIcon: _Kitchen.default,
  Toiletries: _toiletries.default,
  FreeBottledWater: _freeBottledWater.default,
  LocalDrinkIcon: _LocalDrink.default,
  RvHookupIcon: _RvHookup.default,
  StarsIcon: _Stars.default,
  StarsRounded: _StarsRounded.default,
  Stars: _Stars.default,
  AssistantIcon: _Assistant.default,
  TouchAppIcon: _TouchApp.default,
  Liquor: _liquor.default,
  LooksIcon: _Looks.default,
  Balcony: _balcony.default,
  Microwave: _microwave.default,
  HairDryer: _hairDryer.default,
  WineBottle: _wineBottle.default,
  VideoLabelIcon: _VideoLabel.default,
  SetMeal: _setMeal.default,
  BlockedIcon: _blocked_icon.default,
  ExtensionIcon: _Extension.default,
  AALogo: _aalogo.default,
  LocalOfferIcon: _LocalOfferOutlined.default,
  Warning: _Warning.default,
  SuperCertified: _super_certified.default,
  DutyFreeIcon: _duty_free_icon.default,
  CvvIcon: _cvv.default,
  TimelineIcon: _Timeline.default,
  ReceiptIcon: _Receipt.default,
  PhotoCamera: _PhotoCamera.default,
  AirlineSeatReclineNormal: _AirlineSeatReclineNormal.default,
  MoreVertIcon: _MoreVert.default,
  AirplanemodeInactive: _AirplanemodeInactive.default,
  HourglassFullIcon: _HourglassFull.default,
  HotelConfirmedIcon: _hotelConfirmed.default,
  HotelCancelledIcon: _hotelCancelled.default,
  Payments: _payments.default,
  PlaceIcon: _place.default,
  AvTimerIcon: _AvTimer.default,
  ListAltIcon: _ListAlt.default,
  CallSplitIcon: _CallSplit.default,
  ContactPhoneIcon: _ContactPhone.default,
  BoardingPassIcon: _boardingPass.default,
  CheckinIcon: _checkinIcon.default,
  MonetizationOnRounded: _MonetizationOnRounded.default,
  Info: _Info.default,
  SyncAlt: _SyncAlt.default,
  LocalOfferOutlined: _LocalOfferOutlined.default,
  AirlineSeatIndividualSuiteIcon: _airline_seat_individual_suite.default,
  AirLineSeatReclineExtraIcon: _airline_seat_recline_extra.default,
  DoubleArrowIcon: _double_arrow.default,
  EditCalendarIcon: _edit_calendar.default,
  EventSeatIcon: _event_seat.default,
  HealthSafetyIcon: _health_and_safety.default,
  LuggageIcon: _luggage.default,
  NotificationUnfilled: _notificationUnfilled.default,
  AddCircle: _add_circle.default,
  supportAgent: _supportAgent.default,
  NewAccessible: _new_accessible.default,
  NewAdult: _new_adult.default,
  NewBaggage: _new_baggage.default,
  NewBundle: _new_bundle.default,
  NewReschedule: _new_reschedule.default,
  NewCancelFlight: _new_cancel_flight.default,
  NewCheckIn: _new_check_in.default,
  NewChild: _new_child.default,
  NewComfortKit: _new_comfort_kit.default,
  NewCurrencyExchange: _new_currency_exchange.default,
  NewEditContact: _new_edit_contact.default,
  NewExpressBaggage: _new_express_baggage.default,
  NewExtraCarryOn: _new_extra_carry_on.default,
  NewFastpass: _new_fastpass.default,
  NewFerry: _new_ferry.default,
  NewFlatbed: _new_flatbed.default,
  NewFlightIndicator: _new_flight_indicator.default,
  NewInfant: _new_infant.default,
  NewLanding: _new_landing.default,
  NewLayover: _new_layover.default,
  NewLocation: _new_location.default,
  NewLounge: _new_lounge.default,
  NewLuggage: _new_luggage.default,
  NewManageBooking: _new_manage_booking.default,
  NewMeal: _new_meal.default,
  NewOrigin: _new_origin.default,
  NewOthers: _new_others.default,
  NewPoints: _new_points.default,
  NewSeat: _new_seat.default,
  NewSecurity: _new_security.default,
  NewSplit: _new_split.default,
  NewSportsEquipment: _new_sports_equipment.default,
  NewTakeOff: _new_take_off.default,
  NewTechnicalStop: _new_technical_stop.default,
  NewTicket: _new_ticket.default,
  LocationPoint: _location_point.default,
  LocalActivityIcon: _LocalActivity.default,
  ComfortKitIcon: _comfort_kit_icon.default,
  CurtainsIcon: _CurtainsIcon.default,
  PeoplesIcon: _PeopleIcon.default,
  ZoomOutMap: _ZoomOutMap.default,
  cloud: _cloud.default
};
exports.default = _default;